import React, { useEffect, useContext, useState } from 'react';
import {
  params, shape, string, bool, number, useDataModel
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useCustomerInfo } from '../hooks/useCustomerInfo';
import { EmptyCard } from './payment-card-states/empty-card';
import { LoadingCard, ErrorCard, PaymentDataCard } from './payment-card-states';

const PaymentMethodCard = () => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('payment-method-card.ready');
  }, []);
  const { svocID, userID, customerType } = useCustomerInfo();
  const { channel } = useContext(ExperienceContext);
  const [initialLoading, setInitialLoading] = useState(true);
  const channelId = channel === 'mobile' ? 2 : 1;
  const isB2B = customerType.toUpperCase() === 'B2B';

  const { loading, data, error, refetch } = useDataModel('userPayments', {
    variables: { customerAccountId: svocID, userId: userID, channelId },
    ssr: false,
    skip: !userID || !svocID,
    notifyOnNetworkStatusChange: true,
    context: { withAuth: true },
  });

  useEffect(() => {
    if (!loading && initialLoading) {
      setInitialLoading(false);
    }
  }, [loading, initialLoading]);

  const hasErrors = error || data?.errors;
  const hasDefaultPayment = data?.userPayments?.defaultPayment;
  const isLoading = initialLoading || loading;

  const handleRefresh = () => {
    refetch();
  };

  if (isLoading) return <LoadingCard />;

  if (hasErrors && !hasDefaultPayment) return <ErrorCard onRefresh={handleRefresh} />;

  if (!hasDefaultPayment) return <EmptyCard />;


  return <PaymentDataCard payment={data.userPayments.defaultPayment} isB2B={isB2B} />;
};

PaymentMethodCard.displayName = 'PaymentMethodCard';

PaymentMethodCard.dataModel = {
  userPayments: params({
    userId: string().isRequired(),
    customerAccountId: string().isRequired(),
    channelId: number().isRequired(),
  }).shape({
    defaultPayment: shape({
      cardNickName: string(),
      cardBrand: string(),
      cardBrandType: string(),
      cardLast4: string(),
      cardExpiryMonth: string(),
      cardExpiryYear: string(),
      isAuthorizeFlag: bool(),
      t2cStatus: string(),
      isCardExpired: bool(),
      cardStatus: string(),
    }),
  }),
};

export { PaymentMethodCard };
